const FullSkeleton = () => {
  return (
    <output className="m-8 flex h-56 animate-pulse items-center justify-center rounded-lg bg-gray-300 dark:bg-gray-700">
      <span className="sr-only">Loading...</span>
    </output>
  );
};
export default FullSkeleton;
